module.exports = __webpack_public_path__ + "img/offline-heading.2870f637.svg";